export default __webpack_public_path__ + "static/media/7492 - Bailey.09d9bfa3.jpeg";